import { Injectable } from '@angular/core';
import { SignalRService } from './signalr.service';
import { ApiService } from 'src/app/api.service';
import * as signalR from '@microsoft/signalr';
import { LiveNotification } from 'src/app/app.models';
import { PlatformService } from '../platform/platform.service';
import { CustomLoaderService } from 'src/app/shared/custom-loader/custom-loader.service';

@Injectable({
    providedIn: 'root'
})
export class SignalRWebService extends SignalRService {
    connection: signalR.HubConnection;

    constructor(
        protected _apiService: ApiService,
        protected _platformService: PlatformService,
        protected _customLoaderService: CustomLoaderService,
    ) {
        super(_apiService, _platformService, _customLoaderService);
    }

    doConnectHub(): Promise<void> {
        const buildedUrl = `${this._apiService.coreEndpointUrl}/devicehub`;
        this.connection = new signalR.HubConnectionBuilder()
        .withAutomaticReconnect()
        .configureLogging(signalR.LogLevel.None)
        .withUrl(buildedUrl)
        .build();
        this._handleEvents();
        return this.connection.start();
    }

    disconnect(): void {
      this.connection.stop();
    }

    isConnected(): boolean {
        return !!this.connection && this.connection.state == signalR.HubConnectionState.Connected;
    }

    authenticate(userId: string, societeId: string): void {
        if (!!this.connection) {
          this.connection.invoke('AuthenticateUser', userId, societeId);
        }
    }
 
    unauthenticate(): void {
        if (!!this.connection) {
          this.connection.invoke('DisconnectUser');
        }
    }

    private _handleEvents() {
        this.connection.on('SHOW_NOTIFICATION', (notification: LiveNotification) => {
            if (notification.SHOW_NOTIFICATION === true) {
                this._platformService.showNotification('Abworkflow', notification.MESSAGE);
            }
            this.eventListener$.next({ event: "SHOW_NOTIFICATION", datas: notification });
        });
    }
}